import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

export const Container = styled(motion.div)`
  ${({ theme }) => css`
    border-radius: 1rem;
    position: fixed;
    width: 480px;
    height: 270px;
    bottom: 40px;
    right: 40px;
    background: ${theme.colors.background[100]};
    box-shadow: 0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0px 6.7px 5.3px rgba(0, 0, 0, 0.028), 0px 12.5px 10px rgba(0, 0, 0, 0.035),
      0px 22.3px 17.9px rgba(0, 0, 0, 0.042),
      0px 41.8px 33.4px rgba(0, 0, 0, 0.05), 0px 100px 80px rgba(0, 0, 0, 0.07);
    z-index: 9999;

    /* VideoPlayer container */
    > div:last-child {
      width: 100%;
      height: 100%;
      border-radius: 0;
      overflow: hidden;
    }

    :hover {
      aside {
        opacity: 1;
      }
    }
  `};
`;

export const ControlsWrapper = styled.aside`
  ${({ theme }) => css`
    position: absolute;
    z-index: 1;
    top: -3.5rem;
    right: 0;
    height: 5rem;
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
    background: ${theme.colors.background[100]};
    border-radius: 0.5rem 0.5rem 0 0;
    overflow: hidden;
    opacity: 0;
    transition: 180ms ease-in-out;

    svg {
      flex-shrink: 0;
    }

    *:not(h5) {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center !important;
      padding: 0.25rem;
      min-width: 3rem;
      transition: 180ms ease-in-out;

      :not(svg) {
        font-size: 0.625rem;
        font-weight: 400;
        text-align: center;
      }

      :hover {
        background: ${theme.colors.brand.primary.hover};
        color: ${theme.colors.brand.primary.text};
      }
    }

    h5 {
      max-width: 20rem;
      padding: 0.25rem 1rem;
      line-height: 3.25rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    div {
      cursor: move;
    }

    button {
      background: none;
      align-items: flex-start;
    }
  `};
`;
